import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { injectStructuredData } from '@/components/feature/StructuredData';
import { faqs } from '@/mocks/faqs';

export default function Home() {
  useEffect(() => {
    injectStructuredData([
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '蜜桃臀塑形指南',
        url: 'https://peachhipguide.com/',
        description:
          '汇集专业臀部塑形训练方案、饮食营养建议与常见误区解析，帮助你科学高效地打造蜜桃臀。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '蜜桃臀塑形指南',
        url: 'https://peachhipguide.com/',
        description:
          '专注臀部塑形的专业健身内容平台，提供科学的训练方案和饮食建议。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '蜜桃臀塑形指南 - 首页',
        description:
          '科学打造完美翘臀曲线，汇集专业臀部塑形训练方案、饮食营养建议与常见误区解析。',
        url: 'https://peachhipguide.com/',
        inLanguage: 'zh-CN',
        isPartOf: {
          '@type': 'WebSite',
          name: '蜜桃臀塑形指南',
          url: 'https://peachhipguide.com/',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ]);
  }, []);

  return (
    <>
      <HeroSection />
      <CategoryGrid />
      <FeaturedArticles />
      <FAQSection />
      <CTASection />
    </>
  );
}